import HeroSection from "components/NewHome/HeroSection";
import TrustedSection from "components/NewHome/TrustedSection";
import LabTestingSection from "components/NewHome/LabTestingSection";
import CertificationSection from "components/NewHome/CertificationSection";
import ComplianceServicesSection from "components/NewHome/ComplianceServicesSection";
import BusinessSection from "components/NewHome/BusinessSection";
import SupportSection from "components/NewHome/SupportSection";
import ContactSection from "components/NewHome/ContactSection";
import TestimonialSection from "components/NewHome/TestimonialSection";
import FAQSection from "components/NewHome/FAQSection";
import GetInTouchSection from "components/NewHome/GetInTouchSection";
import GradientShadow from "./GradientShadow";
import UploadMediaGrid from "components/NewHome/UploadMediaGrid";

function NewHomePage() {
    return (
        <>
            {/* Hero Section */}
            <section>
                <HeroSection />
            </section>
            {/* Trusted Section */}
            <section className="mt-5 md:mt-5 lg:mt-0">
                <TrustedSection />
            </section>
            {/* Lab-Testing Section */}
            <section>
                <LabTestingSection />
            </section>
            {/* Certification Section */}
            <section className="relative overflow-visible">
                 {/* Large screen only shadows */}
                <GradientShadow position="top-0 right-0" className="hidden lg:block" />
                <GradientShadow position="left-0 bottom-[23%]" className="hidden lg:block" />

                {/* Small screen only shadows */}
                <GradientShadow position="top-[50%] left-0" className="block lg:hidden" />
                <GradientShadow position="right-0 bottom-[5%]" className="block lg:hidden" />
                <CertificationSection />
            </section>
            {/* Compliance Services Section */}
            <section className="bg-gradient-to-b from-deepRedStart to-deepRedEnd">
                <ComplianceServicesSection />
            </section>
            {/* Business Section */}
            <section>
                <BusinessSection />
            </section>
            {/* Support Section */}
            <section className="relative overflow-visible">
                <GradientShadow position="top-0 right-0" className="hidden lg:block" /> {/* Large screen only shadows */}
                <GradientShadow position="top-[30%] right-0" className="block lg:hidden" /> {/* Small screen only shadows */}
                <SupportSection />
            </section>
            {/* Contact Section */}
            <section>
                <ContactSection />
            </section>
            {/* Testimonial Section */}
            <section className="relative overflow-visible">
                <GradientShadow position="top-0 right-0" />
                <TestimonialSection />
            </section>
            {/* FAQ Section */}
            <section className="lg:relative lg:overflow-visible">
                <GradientShadow position="top-0 left-0" className="hidden lg:block" />
                <FAQSection />
            </section >
            {/* Get In Touch Section */}
            <section className="lg:relative lg:overflow-visible">
                <GradientShadow position="bottom-0 right-0" className="hidden lg:block" />
                <GetInTouchSection />
            </section >

            {/* Upload Media Grid Section */}
            {/* <section>
                <UploadMediaGrid />
            </section> */}
        </>
    )
}
export default NewHomePage;